import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-90" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-91" data-mp="32num8qaq072f">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-92" data-mp="32pffmclatjyp">
          Volleyball Ready™
        </p>
        <nav aria-label="Footer" data-id="element-93" data-mp="36n3chl6jxmt8">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-94" data-mp="3ueigrjhw2e74">
            {links.map(link => <li key={link} data-id="element-95" data-mp="36d3qyjl4vnu">
                <a href="#offer" className="whitespace-nowrap transition-colors duration-150 ease-out hover:text-brand" data-id="element-96" data-mp="3levih6kghoia">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-97" data-mp="2ey9yzv7jannc">
          © 2026 Volleyball Ready™. All rights reserved.
        </p>
      </div>
    </footer>;
}